import { Link } from "react-router-dom";
import { Home, ArrowLeft } from "lucide-react";
import Footer from "../components/Footer";
const PrivacyPolicy = () => {
  return <div className="min-h-screen bg-[#F8FAFF]">
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-16 md:pt-20 pb-24 md:pb-32">
        <div className="text-center mb-12 md:mb-16 pt-6 md:pt-10">
          <h1 className="text-3xl md:text-5xl lg:text-6xl mb-4 md:mb-6 font-medium">Privacy Policy</h1>
          <p className="text-base md:text-xl text-gray-600 max-w-3xl mx-auto font-light">
            La tua privacy è importante per noi
          </p>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm">
          <div className="prose prose-gray max-w-none">
            <div className="space-y-6 text-gray-700 leading-relaxed">
              <p className="text-sm text-gray-500 mb-8">
                <strong>Ultimo aggiornamento:</strong> [15 luglio 2025]
              </p>
              
              <p>La presente informativa è resa ai sensi dell'art. 13 del Regolamento UE 2016/679 (&quot;GDPR&quot;) e riguarda il sito web vertigo-agents.com (di seguito, il &quot;Sito&quot;).</p>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">1. Titolare del Trattamento</h2>
                <p>Il titolare del trattamento dei dati personali è:</p>
                <p className="ml-4">
                  Denis Bartolomei<br />
                  Email: denis.bartolomei@gmail.com
                </p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">2. Tipologie di dati trattati</h2>
                <p>Il Sito può raccogliere e trattare esclusivamente l&apos;indirizzo email, fornito volontariamente dall&apos;utente tramite il modulo presente nella pagina.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">3. Finalità del trattamento</h2>
                <p>L&apos;indirizzo email fornito sarà trattato al solo scopo di ricontattare l&apos;utente o l&apos;azienda richiedente per fornire informazioni o un link a una demo dei servizi presentati sul sito. I dati non saranno utilizzati per finalità di marketing né ceduti a terzi.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">4. Base giuridica</h2>
                <p>La base giuridica del trattamento è il consenso esplicito dell&apos;interessato, espresso mediante l&apos;invio volontario del proprio indirizzo email tramite il modulo del sito.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">5. Modalità del trattamento</h2>
                <p>Il trattamento dei dati avviene in modo lecito, corretto e trasparente, tramite strumenti elettronici e nel rispetto delle misure di sicurezza previste dalla normativa. Non vengono utilizzati cookie di profilazione né strumenti di tracciamento (es. Google Analytics o Pixel Meta).</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">6. Conservazione dei dati</h2>
                <p>I dati personali saranno conservati per un periodo massimo di 12 mesi dalla ricezione, dopodiché saranno cancellati, salvo diversa richiesta da parte dell&apos;interessato.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">7. Trasferimento dei dati</h2>
                <p>I dati non sono trasferiti fuori dall&apos;Unione Europea. Il server su cui è ospitato il Sito si trova all&apos;interno dell&apos;UE.</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">8. Diritti dell&apos;interessato</h2>
                <p>L&apos;utente può, in qualsiasi momento, esercitare i diritti previsti dagli articoli 15 e ss. del GDPR, tra cui:</p>
                <ul className="list-disc list-inside ml-4 space-y-1 mt-2">
                  <li>ottenere la conferma dell&apos;esistenza dei propri dati;</li>
                  <li>richiedere l&apos;accesso, la rettifica o la cancellazione;</li>
                  <li>opporsi al trattamento;</li>
                  <li>richiedere la limitazione del trattamento o la portabilità dei dati.</li>
                </ul>
                <p className="mt-3">Per esercitare tali diritti, è possibile scrivere a: denis.bartolomei@gmail.com</p>
              </div>

              <div>
                <h2 className="text-xl font-semibold mb-3 text-gray-900">9. Responsabile della protezione dei dati (DPO)</h2>
                <p>Il titolare non ha nominato un DPO, non essendone tenuto ai sensi dell&apos;art. 37 del GDPR.</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Navigation */}
      <div className="fixed bottom-4 md:bottom-8 left-1/2 transform -translate-x-1/2 flex gap-3 md:gap-6 z-50 bg-white/80 backdrop-blur-sm px-3 py-3 md:px-6 md:py-3 rounded-full shadow-md">
        <Link to="/" className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <Home size={14} className="md:w-4 md:h-4" />
        </Link>
        <Link to="/" className="px-3 md:px-5 h-8 md:h-10 flex items-center justify-center rounded-full bg-gray-200 hover:bg-gray-300 transition-colors duration-300">
          <ArrowLeft size={12} className="md:w-3 md:h-3 mr-1" />
          <span className="text-xs font-medium">Indietro</span>
        </Link>
      </div>
      
      <Footer />
    </div>;
};
export default PrivacyPolicy;